import React from 'react'; // eslint-disable-line

import { Divider, Paper, withStyles } from '@material-ui/core';
import styles, { StyledComponent } from '../../../../styles/styles';
import { AssessmentDecision, ClaimLiability } from '../../assessment-details-reducer';
import { DeathAssessmentDecisionView } from './death-assessment-decision';

interface OwnProps {
    policyNumber: string;
    commencementDate?: Date;
    effectiveDate?: Date;
    decisions: AssessmentDecision[];
    claimLiability: ClaimLiability;
}

type Props = OwnProps & StyledComponent;
const investmentAssessmentView: React.FunctionComponent<Props> = ({
    claimLiability,
    decisions,
    classes,
}: Props) => {
    if (!(decisions && decisions.length > 0)) {
        return <Divider className={classes.marginBottom} />;
    }
    return (
        <Paper className={classes.paper} style={{ marginTop: 2 }}>
            {decisions.map((assessmentDecision, assessmentIndex) => {
                return (
                    <React.Fragment key={assessmentDecision.id}>
                        <DeathAssessmentDecisionView
                            assessmentDecision={assessmentDecision}
                            claimLiability={claimLiability}
                        />
                        {assessmentIndex !== decisions.length - 1 && (
                            <Divider
                                key={`divider_${assessmentDecision.id}`}
                                className={classes.topAndBottomMargin}
                            />
                        )}
                    </React.Fragment>
                );
            })}
        </Paper>
    );
};

export const InvestmentAssessmentView = withStyles(styles)(investmentAssessmentView);
